import { GetterTree } from "vuex";
import { syncState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<syncState, RootState> = {
    getServerTypeTitleById: state => {
        return serverTypeId => {
            if (state.serverTypesCanSync && state.serverTypesCanSync.length == 0) return;
            const serverType = state.serverTypesCanSync.find(x => x.serverTypeID == serverTypeId);
            if (serverType) return serverType.title;
    }},
    getSyncSystemDefaultOrFiltered: state => {
        if (state.syncSystemFilter === "") {
            return state.syncSystem;
        } else {
            return state.syncSystemFiltered;
        }
    },
    getSyncEntryDefaultOrFiltered: state => {
        if(state.syncEntryFilter === "") {
            return state.syncEntries;
        } else {
            return state.syncEntriesFiltered;
        }
    }
};
